module.exports = __webpack_public_path__ + "img/3.48909109.png";